module.exports = __webpack_public_path__ + "img/Union3.3f90f1cd.svg";